webpackJsonp([116674012681294,85547884463409],{

/***/ 62:
/***/ (function(module, exports) {

	module.exports = [{"title":"Features","features":[{"title":"Sync data from Salesforce to RDBMS","description":"Sync data to rdmbs targets with additional targets (like Snowflake, Google Bigquery) are planned"},{"title":"Low maintenance","description":"Complete hand off approach. Specify objects, and it will start doing the work without any other manual touch point"},{"title":"Ability to sync upto few minutes","description":"Being able to sync every few minutes help to get your data in your target and make it available for others"},{"title":"Supports binary objects","description":"Support for syncing binary objects like Attachment/ContentVersion with binary files replicated to Aws S3 (other blob stores support is planned)"},{"title":"New Objects/Fields synced automatically","description":"Based on the configuration, new matching Salesforce Objects/Fields are synced automatically"},{"title":"100% Field History","description":"Capture 100% of history of all fields in Salesforce"},{"title":"Auto Refresh Formula Fields","description":"Auto refresh formula fields at periodic basis"},{"title":"View History in Salesforce","description":"View the Realsync history in Salesforce at Record level with click on a button"},{"title":"Restore Record from History","description":"Restore the Record by picking and choosing the any of the fields from history"}]}]

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(10);
	
	var _Feature = __webpack_require__(18);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	__webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var featureGroups = __webpack_require__(62);
	
	var RealsyncFeatures = function (_Component) {
	  _inherits(RealsyncFeatures, _Component);
	
	  function RealsyncFeatures() {
	    _classCallCheck(this, RealsyncFeatures);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RealsyncFeatures.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "realsync-features-container" },
	      _react2.default.createElement(
	        _reactstrap.CardDeck,
	        null,
	        featureGroups.map(function (group) {
	          return group.features.map(function (feature) {
	            var featureFolder = feature.folder ? "./" + feature.folder + "/" : "./";
	            var images = (feature.images || []).map(function (image) {
	              return { src: __webpack_require__(295)(featureFolder + image) };
	            });
	
	            return _react2.default.createElement(_Feature2.default, {
	              key: feature.title,
	              title: feature.title,
	              description: feature.description,
	              thumbnail: images.length > 0 ? images[0].src : "",
	              images: images
	            });
	          });
	        })
	      )
	    );
	  };
	
	  return RealsyncFeatures;
	}(_react.Component);
	
	exports.default = RealsyncFeatures;
	module.exports = exports["default"];

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/realsync-overview.f28785f5.png";

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./RealsyncFeatures": 31,
		"./RealsyncFeatures.json": 62,
		"./RealsyncFeatures.jsx": 31,
		"./RealsyncFeatures.scss": 67
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 295;


/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _RealsyncFeatures = __webpack_require__(31);
	
	var _RealsyncFeatures2 = _interopRequireDefault(_RealsyncFeatures);
	
	var _reactstrap = __webpack_require__(10);
	
	__webpack_require__(760);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RealsyncPage = function (_Component) {
	  _inherits(RealsyncPage, _Component);
	
	  function RealsyncPage() {
	    _classCallCheck(this, RealsyncPage);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  RealsyncPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "realtask-container" },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Datasert - Appsuite" }),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "div",
	        { className: "main" },
	        _react2.default.createElement(
	          _reactstrap.Container,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Row,
	            null,
	            _react2.default.createElement(
	              _reactstrap.Col,
	              { className: "main-left" },
	              _react2.default.createElement(
	                "h2",
	                null,
	                "Realsync"
	              ),
	              _react2.default.createElement(
	                "h5",
	                null,
	                "Near realsync data sync for Salesforce"
	              ),
	              _react2.default.createElement(
	                "p",
	                null,
	                _react2.default.createElement(
	                  "a",
	                  { href: "/company/contact" },
	                  "Contact Us"
	                ),
	                " to try this out"
	              )
	            ),
	            _react2.default.createElement(
	              _reactstrap.Col,
	              null,
	              _react2.default.createElement("img", {
	                className: "banner-image",
	                src: __webpack_require__(273)
	              })
	            )
	          )
	        )
	      ),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement("br", null),
	      _react2.default.createElement(
	        "div",
	        { className: "features" },
	        _react2.default.createElement(_RealsyncFeatures2.default, null)
	      )
	    );
	  };
	
	  return RealsyncPage;
	}(_react.Component);
	
	exports.default = RealsyncPage;
	module.exports = exports["default"];

/***/ }),

/***/ 760:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-realsync-index-jsx-20575036c5570e7efbe3.js